/**
 * mockCalendar — CalendarPort adapter that fabricates plausible slots.
 * V0.01 default.
 */
export function createMockCalendar() {
  const events = [];
  return {
    async status() { return { status: "connected", vendor: "mock" }; },
    async findAvailableSlots({ fromIso, durationMinutes }) {
      const start = new Date(fromIso);
      const slots = [];
      for (let d = 1; d <= 5; d++) {
        const s = new Date(start.getTime() + d * 24 * 3600 * 1000);
        s.setHours(10, 0, 0, 0);
        const e = new Date(s.getTime() + durationMinutes * 60 * 1000);
        slots.push({ startAt: s.toISOString(), endAt: e.toISOString() });
      }
      return slots;
    },
    async bookMeeting({ actor, slot, subject, agenda }) {
      const ev = {
        id: `evt-${Date.now().toString(36)}`,
        title: subject,
        startAt: slot.startAt, endAt: slot.endAt,
        attendees: [actor.email].filter(Boolean),
        notes: agenda,
        conferenceUrl: `https://meet.example.com/${Math.random().toString(36).slice(2, 10)}`,
      };
      events.push(ev);
      return ev;
    },
    async cancelMeeting(id) {
      const i = events.findIndex((e) => e.id === id);
      if (i >= 0) events.splice(i, 1);
    },
    async listEvents() { return events.slice(); },
  };
}
